export default __webpack_public_path__ + "static/media/bg-image.9e18f386.png";